import React from 'react';

/**
 * Simple choice modal for "Add meal type" / "Add option" flows.
 * onSelect receives the full item object (or value for legacy callers via item.value).
 */
export default function MealSlotChoiceModal({
  open,
  title,
  items = [],
  onClose,
  onSelect,
  /** When true, closes modal before calling onSelect (template add-option flow). */
  closeBeforeSelect = false,
}) {
  if (!open) return null;

  const handleSelect = (item) => {
    if (closeBeforeSelect && item?.value === '__new__') {
      onClose?.();
      onSelect?.(item);
      return;
    }
    onSelect?.(item);
    onClose?.();
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="meal-slot-choice-modal-title"
    >
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-xl border border-gray-200 max-w-sm w-full max-h-[80vh] overflow-hidden flex flex-col">
        <h2
          id="meal-slot-choice-modal-title"
          className="text-lg font-semibold text-gray-900 px-5 pt-5 pb-2"
        >
          {title}
        </h2>
        <p className="text-sm text-gray-500 px-5 pb-4">Choose one to add:</p>
        <div className="overflow-y-auto px-3 pb-5">
          {items.map((item) => (
            <button
              key={item.value}
              type="button"
              onClick={() => handleSelect(item)}
              className="w-full text-left px-4 py-3 rounded-lg text-base font-medium text-gray-800 hover:bg-orange-50 border border-transparent hover:border-orange-200 transition-colors focus:outline-none focus:ring-0"
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
